import React, { useEffect } from 'react';
import { TTypeOfEditRestaurantModalWindow } from '../../../../../../../../editRestaurantState/editRestaurantContext';
import { Form, Radio } from 'antd';
import { ValidateFields } from 'rc-field-form/es/interface';
import { IsCharityEnabledCheckBox } from './components/IsCharityEnabledCheckBox';
import { CharityNameField } from './components/CharityNameField';
import { CharityLogoUploader } from './components/CharityLogoUploader';
import { CharityAmountField, CHARITY_AMOUNT_FIELD_NAMES } from './components/CharityAmountField';

interface IProps {
	toggleIsCharityEnabled: () => void;
	changeCharityName: (value: string) => void;
	setCharityLogoFile: (fileId: Nullable<string>) => void;
	setCharityAmount0: (value: null | number) => void;
	setCharityAmount1: (value: null | number) => void;
	setCharityAmount2: (value: null | number) => void;
	setCharityAmount3: (value: null | number) => void;
	setDefaultCharityAmountIndex: (value: number) => void;
	changeTypeOfModalWindow: (value: TTypeOfEditRestaurantModalWindow) => void;
	revalidateForm: ValidateFields;
	isCharityEnabled: boolean;
	charityLogoFileId: Nullable<string>;
	charityLogoPath: Nullable<string>;
	charityAmount0: null | number;
	charityAmount1: null | number;
	charityAmount2: null | number;
	charityAmount3: null | number;
	defaultCharityAmountIndex: Nullable<number>;
}

export const Charity: React.FC<IProps> = React.memo(
	({
		toggleIsCharityEnabled,
		changeCharityName,
		setCharityLogoFile,
		setCharityAmount0,
		setCharityAmount1,
		setCharityAmount2,
		setCharityAmount3,
		setDefaultCharityAmountIndex,
		changeTypeOfModalWindow,
		revalidateForm,
		isCharityEnabled,
		charityLogoFileId,
		charityLogoPath,
		charityAmount0,
		charityAmount1,
		charityAmount2,
		charityAmount3,
		defaultCharityAmountIndex,
	}) => {
		useEffect(() => {
			if (!isCharityEnabled) {
				revalidateForm(['charityName', ...CHARITY_AMOUNT_FIELD_NAMES]).catch(() => undefined);
			}
		}, [isCharityEnabled, revalidateForm]);

		return (
			<>
				<IsCharityEnabledCheckBox
					toggleIsCharityEnabled={toggleIsCharityEnabled}
					isCharityEnabled={isCharityEnabled}
				/>
				<div className="w-full flex justify-between gap-7.5">
					<CharityNameField changeCharityName={changeCharityName} isCharityEnabled={isCharityEnabled} />
					<div className="flex-1" />
				</div>
				<div className="w-full mb-6 flex justify-between gap-7.5">
					<CharityLogoUploader
						setCharityLogoFile={setCharityLogoFile}
						changeTypeOfModalWindow={changeTypeOfModalWindow}
						charityLogoFileId={charityLogoFileId}
						charityLogoPath={charityLogoPath}
						isCharityEnabled={isCharityEnabled}
					/>
					<div className="flex-1" />
				</div>
				<Form.Item className="m-0" name="defaultCharityAmountIndex">
					<Radio.Group className="w-full">
						<div className="w-full mb-4.5 flex justify-between gap-7.5">
							<CharityAmountField
								setCharityAmount={setCharityAmount0}
								setDefaultCharityAmountIndex={setDefaultCharityAmountIndex}
								charityAmountIndex={0}
								charityAmount={charityAmount0}
								defaultCharityAmountIndex={defaultCharityAmountIndex}
								isCharityEnabled={isCharityEnabled}
							/>
							<CharityAmountField
								setCharityAmount={setCharityAmount1}
								setDefaultCharityAmountIndex={setDefaultCharityAmountIndex}
								charityAmountIndex={1}
								charityAmount={charityAmount1}
								defaultCharityAmountIndex={defaultCharityAmountIndex}
								isCharityEnabled={isCharityEnabled}
							/>
						</div>
						<div className="w-full mb-4.5 flex justify-between gap-7.5">
							<CharityAmountField
								setCharityAmount={setCharityAmount2}
								setDefaultCharityAmountIndex={setDefaultCharityAmountIndex}
								charityAmountIndex={2}
								charityAmount={charityAmount2}
								defaultCharityAmountIndex={defaultCharityAmountIndex}
								isCharityEnabled={isCharityEnabled}
							/>
							<CharityAmountField
								setCharityAmount={setCharityAmount3}
								setDefaultCharityAmountIndex={setDefaultCharityAmountIndex}
								charityAmountIndex={3}
								charityAmount={charityAmount3}
								defaultCharityAmountIndex={defaultCharityAmountIndex}
								isCharityEnabled={isCharityEnabled}
							/>
						</div>
					</Radio.Group>
				</Form.Item>
			</>
		);
	},
);
